import React from 'react';
import "./css/dashboard.css";
import {API_URI} from "../../constant/Config"
import {t, DATE_FORMAT} from '../../constant/i18n';
import {Typography, Form, Input, Button, Checkbox, DatePicker,message} from "antd";
import axios from "axios";
import moment from 'moment';

const {Title, Text} = Typography;
const layoutForm = {
    labelCol: {span: 24},
    wrapperCol: {span: 24},
}
const tailLayout = {
    wrapperCol: {offset: 0, span: 24},
};

class OrderBlocDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            id: this.props.id,
            dataCmd: false,
        }
    }

    async componentDidMount() {
        const dataCmd = await this.getDetailsCmd()
        await this.setState({dataCmd: dataCmd})
    }

    getDetailsCmd = async () => {
        var token = localStorage.getItem('membre_token');
        let dataCmd = await axios.post(API_URI + '/api_member/details_order', {
            id: this.state.id,
        },{
            headers: {
                'Authorization': token
            }
        });
        return dataCmd.data;
    }

    onFinish = async values => {

        const postData  = {
            ...values,
            id: this.state.id,
        }
        var token = localStorage.getItem('membre_token');
        const res = await axios.post(API_URI + '/api_member/update_details_order', postData, {
            headers: {
                'Authorization': token
            }
        });
        message.success(t('orderBlocDetails.profileUpdated'), 5);
    };

    onFinishFailed = errorInfo => {
        console.log('Failed:', errorInfo);
    };


    render() {
        if (this.state.dataCmd) {
            return (
                <di>
                    <Form
                        {...layoutForm}
                        name="basic"
                        onFinish={this.onFinish}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <Form.Item
                            label={t('orderBlocDetails.passportNumber')}
                            name="passeportnum"
                            rules={[{required: true, message: t('common.completeInfo')}]}
                            initialValue={this.state.dataCmd.data.passeportnum}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            label={t('orderBlocDetails.passportPlace')}
                            name="passeportlieu"
                            rules={[{required: true, message: t('common.completeInfo')}]}
                            initialValue={this.state.dataCmd.data.passeportlieu}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            label={t('orderBlocDetails.passportFullName')}
                            name="nompasseport"
                            rules={[{required: true, message: t('common.completeInfo')}]}
                            initialValue={this.state.dataCmd.data.nompasseport}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            label={t('orderBlocDetails.passportIssueDate')}
                            name="passeportdatedelivr"
                            rules={[{required: true, message: t('common.completeInfo')}]}
                            //initialValue={(this.state.dataCmd.passeportdatedelivr)?moment(this.state.dataCmd.passeportdatedelivr, 'YYYY-MM-DD'):null}
                            //initialValue={(this.state.dataCmd.passeportdatedelivr)?moment(this.state.dataCmd.passeportdatedelivr+'T01:00:00', 'YYYY-MM-DDTHH:mm:ss'):null}
                            //initialValue={(this.state.dataCmd.passeportdatedelivr)?moment(this.state.dataCmd.passeportdatedelivr+'T01:00:00', 'YYYY-MM-DDTHH:mm:ss'):null}

                            initialValue={(this.state.dataCmd.datesOrder.passeportdatedelivr)?moment.unix(this.state.dataCmd.datesOrder.passeportdatedelivr):null}
                        >
                            <DatePicker format={DATE_FORMAT} />
                        </Form.Item>

                        <Form.Item
                            label={t('orderBlocDetails.passportExpiry')}
                            name="passeportexp"
                            rules={[{required: true, message: t('common.completeInfo')}]}
                            //initialValue={(this.state.dataCmd.data.passeportexp)?moment(this.state.dataCmd.data.passeportexp+'T01:00:00', 'YYYY-MM-DDTHH:mm:ss'):null}

                            initialValue={(this.state.dataCmd.datesOrder.passeportexp)?moment.unix(this.state.dataCmd.datesOrder.passeportexp):null}
                        >
                            <DatePicker format={DATE_FORMAT} />
                        </Form.Item>

                        <Form.Item
                            label={t('orderBlocDetails.visaNumber')}
                            name="visa"
                            rules={[{required: false, message: t('common.completeInfo')}]}
                            initialValue={this.state.dataCmd.data.visa}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            label={t('orderBlocDetails.insuranceCompany')}
                            name="compagnieassurance"
                            rules={[{required: true, message: t('common.completeInfo')}]}
                            initialValue={this.state.dataCmd.data.compagnieassurance}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            label={t('orderBlocDetails.insurancePolicy')}
                            name="numpoliceassurance"
                            rules={[{required: true, message: t('common.completeInfo')}]}
                            initialValue={this.state.dataCmd.data.numpoliceassurance}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item
                            label={t('orderBlocDetails.additionalNotes')}
                            name="gpCommandescolDatereportNote"
                            rules={[{required: false, message: t('common.completeInfo')}]}
                            initialValue={this.state.dataCmd.data.gpCommandescolDatereportNote}
                        >
                            <Input/>
                        </Form.Item>

                        <Form.Item {...tailLayout}>
                            <Button type="primary" htmlType="submit">
                                {t('orderBlocDetails.validateInfo')}
                            </Button>
                        </Form.Item>
                    </Form>
                </di>
            )
        } else {
            return (<div>{t('common.loadingData')}</div>)
        }
    }
}

export default OrderBlocDetails